<template>
  <th v-if="isHeader">
    {{ rowField["title"] | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <label class="switch switch-sm switch-text switch-success mb-0">
        <input type="checkbox" @change="itemAction($event)" :checked="getObjectValue(rowData,rowField['sortField'])" class="switch-input">
        <span class="switch-label" data-on="Yes" data-off="No"></span>
        <span class="switch-handle"></span>
      </label>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowField: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    getObjectValue (object, keys) {
      return keys.split('.').reduce((o, k) => (o || {})[k], object)
    },
    itemAction (e) {
      this.$parent.$emit('table-switch-event', {event: this.rowField['callbackEvent'], flag: this.rowField['flag'], value: e.target.checked, row: this.rowData})
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTableSwitch.vue?d04bb2c4